import httpClient from "../http/http-client";
import { IProductComponent, IProductComponentFull } from './product-component.model';

export default class ProductComponentService {
  http;

  constructor() {
    this.http = httpClient
  }

  async create(details: IProductComponent): Promise<IProductComponent> {
    return this.http.post(`product-component/create`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAll(): Promise<IProductComponent[]> {
    return this.http.get(`product-component`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOne(componentId: string): Promise<IProductComponentFull> {
    return this.http.get(`product-component/${componentId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async addConversion(
    productComponentId: string,
    conversionId: string,
    unitsConsumed: number,
    perXProductComponents: number,
    groupId: string,
    locationId: string): Promise<IProductComponent> {
    return this.http.post(`product-component/${productComponentId}/add-conversion`,
      {
        conversionId: conversionId,
        unitsConsumed: unitsConsumed,
        perXProductComponents: perXProductComponents,
        groupId: groupId,
        locationId: locationId
      })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async removeConversion(productComponentId: string, conversionId: string): Promise<IProductComponent> {
    return this.http.post(`product-component/${productComponentId}/remove-conversion`,
      {
        conversionId: conversionId
      })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async update(productComponentId: string, details: IProductComponent): Promise<IProductComponent> {
    return this.http.patch(`product-component/${productComponentId}`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}